import { client } from "./_base";

export const producers = client("producer", item => ({
  ...item,
}));
